<template>
<div class="footer-bar">
  <div class="col-xs-10 col-sm-10 col-md-11 col-lg-11 float-Right">
    <div class="row row-Style">
      <div class="col-xs-11 col-sm-11 col-md-11 col-lg-11 width admin-Panel-Padding font-size-2vw admin-Panel-BG text-align-center">
        {{title}}
      </div>  
    </div> 
  </div>
</div>  
</template>

<script>
export default {
  name: 'footer-bar',
  data: function () {
    return {
      title: '© 2024 Mentora Institute. All rights reserved. Mentora™. Patent Pending.'
    }
  }
}
</script>

<style scoped>
.width
{
  width: 100%;
}
.row-Style
{
  border: solid 1px greenyellow;
}
.footer-bar
{
  overflow-y: hidden !important;
  border: solid 1px blue;
  position: absolute;
  bottom: -20px;
}
.float-Right
{
	float: right;
}
.admin-Panel-BG
{
  background-color: #ffffff;
}
.text-align-center
{
  text-align: center;
}
.admin-Panel-Padding
{
  padding:0.1% 0% 0.1% 2%;
}
.font-size-2vw
{
  font-size: 1vw;
}
</style>


// WEBPACK FOOTER //
// src/components/FooterBar.vue